// eslint-disable-next-line import/prefer-default-export
export function NumberFilter(v) {
  return String(v).replace(/(\d+?)(?=(?:\d{3})+$)/g, '$1,');
}
